import React from "react";
import {
  View,
  Modal,
  StyleSheet,
  SafeAreaView,
  TouchableOpacity,
} from "react-native";
import { IMessage, MessageImageProps } from "react-native-gifted-chat";
import { Img, Icon, Button } from "components";

import { colors } from "assets/constants";
import { useFlag } from "hooks";

export default function ChatImage(props: MessageImageProps<IMessage>) {
  const { currentMessage } = props;

  const { flg: full, on: showFull, off: hideFull } = useFlag();

  return (
    <>
      <TouchableOpacity activeOpacity={1} onPress={showFull}>
        <Img
          source={{ uri: currentMessage?.image?.uri || currentMessage?.image }}
          resizeMode={"cover"}
          style={styles.image}
        />
        <View style={styles.placeholderContainer}>
          <Icon
            type="entypo"
            name="images"
            size={120}
            color={colors.white + "22"}
          />
        </View>
      </TouchableOpacity>

      <Modal visible={full} animationType="fade" onRequestClose={hideFull}>
        <SafeAreaView style={styles.fullScreenImgContainer}>
          <Img
            resizeMode={"contain"}
            source={{
              uri: currentMessage?.image?.uri || currentMessage?.image,
            }}
            style={{ ...styles.fullImg }}
          />
          <Button
            onPress={hideFull}
            circle={45}
            bgColor={colors.lightGlass}
            absolute
            top={10}
            left={10}
            icon={{ name: "x", size: 25, color: colors.white }}
          />
        </SafeAreaView>
      </Modal>
    </>
  );
}

const styles = StyleSheet.create({
  image: {
    width: "100%",
    aspectRatio: 1,
    marginBottom: 5,
    backgroundColor: colors.black + "dd",
  },

  placeholderContainer: {
    width: "100%",
    height: "100%",
    position: "absolute",
    alignItems: "center",
    justifyContent: "center",
  },

  fullScreenImgContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.black,
  },

  fullImg: { width: "100%", height: "100%", backgroundColor: colors.black },
});
